// @flow

// Effect Manager
import { fork } from 'redux-saga/effects'

// Sagas
import watchAssetOperations from './operations'
import { watchOperations } from 'hfty-operator-asset'
import { uploadFieldBordersSaga } from 'fc-upload-borders'

// Selectors
import operations$ from '../selectors/operations'

export default function *main (): Generator<*, void, *> {
  yield fork(watchAssetOperations)
  yield fork(watchOperations, { operations$ })
  yield fork(uploadFieldBordersSaga)
}
